
export class OrgStructure {
  id?: number;
  version?: number;

  leftId: number;
  rightId: number;
  depth: number;

  code: string;
  description: string;
  group: string;
  name: string;
  orgId: number;

  managerId: number;
  managerName: string;

  execAsstId: number;
  ownerId: number;

  reportsTo: number;

}